import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Loading } from '../../shared/ui/components';
import { useSession } from '../session/SessionProvider';
import { AuthLayout } from './AuthLayout';
import { AFTER_CONFIRM_KEY } from './RegisterPage';

type State = { status: 'working' } | { status: 'done' } | { status: 'error'; message: string };

/** Destino del enlace del correo de confirmación. El token es la prueba; no requiere sesión. */
export function ConfirmEmailPage() {
  const [params] = useSearchParams();
  const { state: session } = useSession();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<State>(token ? { status: 'working' } : { status: 'error', message: 'El enlace está incompleto.' });
  const sent = useRef(false);

  useEffect(() => {
    // El token es de un solo uso: evitar el doble envío del modo estricto de React.
    if (!token || sent.current) return;
    sent.current = true;
    api
      .post('/identity/email-verifications/confirm', { token })
      .then(() => setState({ status: 'done' }))
      .catch((e: unknown) => setState({ status: 'error', message: errorMessage(e) }));
  }, [token]);

  // Al confirmar, se entra y se sigue a donde iba (unirse a su iglesia, registrar la suya…).
  let after = '/app';
  try {
    after = localStorage.getItem(AFTER_CONFIRM_KEY) ?? '/app';
  } catch {
    // sin almacenamiento
  }
  const next = session.status === 'authenticated' ? after : `/entrar?volver=${encodeURIComponent(after)}`;

  return (
    <AuthLayout title="Confirmar correo">
      {state.status === 'working' ? <Loading label="Confirmando tu correo…" /> : null}
      {state.status === 'done' ? (
        <>
          <Alert tone="success">¡Listo! Tu correo quedó confirmado.</Alert>
          <p>
            <Link to={next} className="btn btn--primary btn--block">
              {session.status === 'authenticated' ? 'Continuar' : 'Iniciar sesión'}
            </Link>
          </p>
        </>
      ) : null}
      {state.status === 'error' ? (
        <>
          <Alert>{state.message}</Alert>
          <p className="muted">
            Puedes pedir un enlace nuevo desde <Link to="/entrar">Iniciar sesión</Link>: escribe tu correo y contraseña y toca «Enviarme el enlace otra vez».
          </p>
        </>
      ) : null}
    </AuthLayout>
  );
}
